import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksServicePayments: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
	},
	getRegulationsStagesPlanWorksServicePaymentPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_PREVIEW,
	},
	getRegulationsStagesPlanWorksServicePaymentPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_POPUP,
	},
	createRegulationsStagesPlanWorksServicePayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.CREATE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
	},
	getRegulationsStagesPlanWorksServicePayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT
	},
	patchRegulationsStagesPlanWorksServicePayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.PATCH_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
	},
	putRegulationsStagesPlanWorksServicePayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.PUT_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
	},
	deleteRegulationsStagesPlanWorksServicePayment: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
				.DELETE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
	},
}
